import { render } from "./PopUpPreviewQcmQuestion.vue?vue&type=template&id=37f1f792"
import script from "./PopUpPreviewQcmQuestion.vue?vue&type=script&lang=js"
export * from "./PopUpPreviewQcmQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__